import { type ActionRecord } from "./ActionRecord";

/**
 * The Action Hub's ingestion actions, by name. Recognized by name as well as
 * by tag because some of them (`ros_ingestion`) are not tagged `ingestion`.
 */
export const INGESTION_ACTION_NAMES: readonly string[] = [
  "ros_ingestion",
  "ulog_ingestion",
  "csv_ingestion",
  "parquet_ingestion",
  "journal_log_ingestion",
  "video_ingestion",
  "ardupilot_ingestion",
];

/**
 * Whether an action turns files into topics, which is the job of an ingestion
 * rule rather than a trigger. Pass the action record when it is loaded; with
 * only a reference, the name alone decides.
 */
export function isIngestionAction(
  action: Pick<ActionRecord, "name"> & { tags?: readonly string[] | null },
): boolean {
  return (
    INGESTION_ACTION_NAMES.includes(action.name) ||
    (action.tags ?? []).some((tag) => tag.toLowerCase() === "ingestion")
  );
}
